/*!

=========================================================
* Material Dashboard PRO React - v1.9.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Switch, Redirect } from "react-router-dom";
import { useSnackbar } from 'notistack';
//import { ApolloProvider } from '@apollo/client';
import { ApolloProvider } from "@apollo/client";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import PublicLayout from "layouts/Public.js";

import "assets/fonts/SofiaPro-SemiBold/styles.css";
import "assets/fonts/SofiaProRegular/styles.css"

import "assets/scss/material-dashboard-pro-react.scss?v=1.9.0";
import ProtectedRoute from "components-lib/ProtectedRoute/ProtectedRoute";
import PublicRoute from "components-lib/PublicRoute/PublicRoute";
import PublicRouteQueries from "components-lib/PublicRouteQueries/PublicRouteQueries";
import { getApolloClient } from "./configFiles/apollo";
import WithSnackbar from "./components-lib/WithSnackbar/WithSnackbar";
import { IntlProvider, addLocaleData } from 'react-intl';
import { getSelectedLanguage } from "./helpers/helpers";
import skConfig from './locales/config/sk';
import enConfig from './locales/config/en';
import { injectIntl } from 'react-intl';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { Provider } from 'react-redux';
import store from 'redux/store';

// css
import "./assets/css/others.css"


const theme = createMuiTheme({
    body: {
        fontFamily: '"Nunito Sans", sans-serif',
    },
    typography: {
        fontFamily: '"Nunito Sans", sans-serif',
    }
});
const hist = createBrowserHistory();

const App = injectIntl(({ intl }) => {

    const { enqueueSnackbar } = useSnackbar();
    const client = getApolloClient(enqueueSnackbar, hist, intl);
    var urlString = window.location.pathname
    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <ApolloProvider client={client}>
                    <Router history={hist}>
                        <Switch>
                            <ProtectedRoute path="/admin" component={AdminLayout} lastUrlString={urlString} />
                            <PublicRoute path="/auth" component={AuthLayout} />
                            <PublicRouteQueries path="" component={PublicLayout} />
                            <Redirect from="/" to="/admin/profile" />
                        </Switch>
                    </Router>
                </ApolloProvider>
            </ThemeProvider>
        </Provider>


    )
});



const Context = React.createContext();

const IntlProviderWrapper = ({ children }) => {
    const selectedLanguageStored = getSelectedLanguage() === 'sk' ? skConfig : enConfig;

    const [selectedLanguage, setSelectedLanguage] = React.useState(selectedLanguageStored);

    addLocaleData([
        { locale: 'sk', pluralRuleFunction: (n, ord) => null },
        { locale: 'en', pluralRuleFunction: (n, ord) => null }
    ]);

    const handleLanguageChange = (locale) => {
        if (locale === 'sk') {
            return setSelectedLanguage(skConfig);
        } else if (locale === 'en') {
            return setSelectedLanguage(enConfig);
        } else {
            return setSelectedLanguage(skConfig);
        }
    }

    return (
        <Context.Provider
            value={{
                handleLanguageChange: handleLanguageChange,
                selectedLanguage: selectedLanguage.locale
            }}
        >
            <IntlProvider
                locale={selectedLanguage.locale}
                messages={selectedLanguage.messages}
                defaultLocale="sk"
            >
                {children}
            </IntlProvider>
        </Context.Provider>
    );
};

export { Context as IntlContext };

ReactDOM.render(
    <IntlProviderWrapper>
        <WithSnackbar>
            <App />
        </WithSnackbar>
    </IntlProviderWrapper>,
    document.getElementById("root")
);
